import { render, staticRenderFns } from "./ReviewsCard.vue?vue&type=template&id=73821e94&scoped=true"
import script from "./ReviewsCard.vue?vue&type=script&lang=js"
export * from "./ReviewsCard.vue?vue&type=script&lang=js"
import style0 from "./ReviewsCard.vue?vue&type=style&index=0&id=73821e94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73821e94",
  null
  
)

export default component.exports